import segmentation from './segmentation';
import model from './model';

export default {
  segmentation,
  model,
};
